import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation DocumentImageInfiniteScrollList_ArchiveDocumentImage(
    $documentImageId: ID!
  ) {
    changeDocumentImageStatus(
      documentImageId: $documentImageId
      newStatus: archived
    ) {
      ok
    }
  }
`)

export const useArchiveDocumentImageMutation = (
  options: Omit<
    UseMutationOptions<void, unknown, string, unknown>,
    'mutationFn'
  > = {},
) => {
  const { t } = useTranslation()
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: async (documentImageId) => {
      const result = await graphQLRequest({
        document,
        variables: { documentImageId },
      })
      const ok = result.changeDocumentImageStatus?.ok ?? false
      if (!ok) {
        throw new Error(t('archive_failed_4'))
      }
    },
    ...options,
  })
}
